/*
 * collapse descendant element 
 * see fieldMap.html
 * usage: <h4 cfn-collapse>Header</h4>
 *        <div>Hide me</div>
 * 
 * mmn
 */

angular.module('cfn').directive('cfnCollapse', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var expanded = !element.hasClass('collapsed');
        element
          .css('cursor', 'pointer')
          .toggleClass('collapsed', !expanded)
          .toggleClass('expanded', expanded)
          .on('click', function(event) {
            var expanded = !$(event.target).hasClass('collapsed');
            expanded = !expanded;
            $(event.target)
              .toggleClass('collapsed', !expanded)
              .toggleClass('expanded', expanded)
              .toggleClass('no-print', !expanded)
              .next()
              .slideToggle('fast');
          })
          .next()
          .toggle(expanded);
      }
    };
  }
]);
